// src/pages/auth/LoginPage.jsx
import React from 'react';
// Constants
import { CompanyName } from '../../utils/Constants';
// Components
import Navbar from '../../components/nav/Navbar';
import { HelmetItem } from '../../components/utils/HelmetItem';
import LoginForm from '../../components/forms/LoginForm';

function LoginPage() {
  return (
    <>
      {/* Tab Data */}
      <HelmetItem
        PageName='Login'
        desc={`Log in to your ${CompanyName} account to access exclusive features.`}
        additionalMeta={[]}
        structuredData={[]}
      />

      {/* Page */}
      <div className='grid min-h-screen w-full font-poppins bg-colour2 text-colour1'>
        <div className='grid grid-rows-reg w-full min-h-screen'>
          {/* Navigation */}
          <Navbar />

          {/* Skip link */}
          <a
            href='#main-content'
            className='sr-only focus:not-sr-only focus:absolute focus:top-2 focus:left-2 focus:z-50 bg-white rounded-md px-3 py-2 shadow'
          >
            Skip to main content
          </a>

          {/* Main content */}
          <main id='main-content' className='grid w-full'>
            <section className='grid w-full'>
              <div className='grid px-8 md:px-10 lg:container items-center lg:mx-auto py-10 max-w-2xl mx-auto'>
                {/* Card wrapper to match Contact page aesthetic */}
                <article className='grid gap-6 bg-colour5/10 backdrop-blur-sm p-4 lg:p-4 rounded-2xl shadow-cardShadowBold neon-border max-w-2xl w-full mx-auto'>
                  <div className='bg-black grid grid-rows-reg items-center'>
                    <header className='grid gap-2 text-center py-4'>
                      <h1 className='text-2xl md:text-3xl text-colour1 font-semibold neon_text_duo_magenta_violet'>
                        Sign in to your account
                      </h1>
                      <div className='neon_line' />
                    </header>

                    {/* Form card (mirrors Contact form card tone) */}
                    <div className='grid bg-colour1/5 p-6 lg:p-8 rounded-2xl shadow-cardShadowBold'>
                      <LoginForm />
                    </div>
                  </div>
                </article>
              </div>
            </section>
          </main>
        </div>
      </div>
    </>
  );
}

export default LoginPage;
